import * as React from 'react';
import { useAppContext } from '@ids/context';

export default function useFocusableSections() {
    const { location } = useAppContext();

    React.useEffect(() => {
        const hash = location.hash.replace('#', '');
        let int: ReturnType<typeof setInterval> | null = null;
        if (hash) {
            int = setInterval(() => {
                if (hash) {
                    try {
                        const el = document.querySelector(`#${hash}`);
                        if (el) {
                            el.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start',
                            });
                            if (int) {
                                clearInterval(int);
                            }
                        }
                    } catch (e) {
                        window.scrollTo(0, 0);
                        if (int) {
                            clearInterval(int);
                        }
                    }
                }
            }, 100);
        }

        return () => {
            if (int != null) {
                clearInterval(int);
            }
        };
    }, [location]);
}
